import { ChartData } from '../../types/chart';
import { ChartBar } from './ChartBar/ChartBar';
import staticStyles from './chartContent.module.scss';

interface ChartContentProps extends ChartData {
  maxValue: number;
  isVisible: boolean;
}

export const ChartContent = ({
  data,
  heading,
  styles,
  maxValue,
  isVisible,
}: ChartContentProps) => {
  return (
    <article className={`${staticStyles.chart} ${styles.background}`}>
      <span
        className={`${staticStyles.heading} ${styles.heading} ${isVisible ? staticStyles.isVisible : ''}`}
      >
        {heading}
      </span>
      <ul className={staticStyles.bar_container}>
        {data.map((item) => (
          <ChartBar
            item={item}
            maxValue={maxValue}
            styles={styles}
            key={item.axis_label}
            isVisible={isVisible}
          />
        ))}
      </ul>
    </article>
  );
};
